import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/opportunities/$opportunityId/properties')({
  component: PropertiesRedirect,
})

function PropertiesRedirect() {
  const { opportunityId } = Route.useParams()

  return <Navigate to='/opportunities/$opportunityId' params={{ opportunityId }} replace />
}
